export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13976.c4c9c20d.jpg";